<pr-icon-chip
  [icon]="status | map: statusIcon"
  [iconClass]="status | map: statusColor"
  [matTooltip]="tooltip"
>
  {{ status ?? '' | splitCamel | titlecase }}
</pr-icon-chip>
